import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";

const STAGES = ["Writing the copy", "Composing the visuals", "Finishing touches"];
const STAGE_MS = 12_000;

// Shown in a tile on /created while post.status === "generating".
// Full-size placeholder with a shimmer overlay, a spinner, and a rotating
// status line that advances through the stages and STOPS at the last one —
// never loops back, so copy never contradicts itself.
export function GeneratingPostMedia({ postId }: { postId: string }) {
  // Seed the start index so a row of tiles isn't in lockstep.
  const seed = simpleHash(postId) % STAGES.length;
  const [stageIndex, setStageIndex] = useState(seed);

  useEffect(() => {
    if (stageIndex >= STAGES.length - 1) return;
    const t = setTimeout(() => {
      setStageIndex((s) => Math.min(s + 1, STAGES.length - 1));
    }, STAGE_MS);
    return () => clearTimeout(t);
  }, [stageIndex]);

  return (
    <div className="relative h-full overflow-hidden bg-muted">
      {/* Shimmer sweep — visible movement so the tile reads as "working" */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-background/60 to-transparent animate-shimmer [background-size:200%_100%]" />
      <div className="relative h-full flex flex-col items-center justify-center gap-3 px-4">
        <Loader2 className="h-5 w-5 animate-spin text-primary/70" />
        <p
          key={stageIndex}
          className="text-sm font-medium text-muted-foreground text-center animate-in fade-in duration-500"
        >
          {STAGES[stageIndex]}
        </p>
      </div>
    </div>
  );
}

function simpleHash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}
